import anastasiaKapchenova from '../images/sell-with-us/reviews/anastasia-kapchenova.png';
import anastasiaKapchenovaPhoto from '../images/sell-with-us/reviews/anastasia-kapchenova-photo.jpg';
import simonSimon from '../images/sell-with-us/reviews/simon-simon.png';
import annaKapchenova from '../images/sell-with-us/reviews/anna-kapchenova.png';
import benjaminZw from '../images/sell-with-us/reviews/benjamin-zw.png';
import temaDobry from '../images/sell-with-us/reviews/tema-dobry.png';
import danielSalimov from '../images/sell-with-us/reviews/daniel-salimov.png';
import grishaKhaspekyan from '../images/sell-with-us/reviews/grisha-khaspekyan.png';
import grishaKhaspekyanPhoto from '../images/sell-with-us/reviews/grisha-khaspekyan-photo.jpg';
import ivanRumyantsev from '../images/sell-with-us/reviews/ivan-rumyantsev.png';
import vartanMirakyan from '../images/sell-with-us/reviews/vartan-mirakyan.png';
import stephanieT from '../images/sell-with-us/reviews/stephanie-t.png';
export const REVIEWS = [
  {
    name: 'Анастасия Капченова',
    avatar: anastasiaKapchenova,
    caption: 'Довольный клиент',
    headline: 'ИДЕАЛЬНЫЕ ЧАСЫ',
    text: `Я купила две пары часов от Sany Watches — одни для себя, другие в подарок, и, честно говоря, я очень довольна!

Мои часы подходят буквально ко всему, и я уже получила комплименты. Те, что я подарила, тоже произвели фурор — очень понравились!

Спасибо Sany Watches за профессиональное обслуживание и помощь в выборе именно тех часов, которые я хотела 🫶🏻`,
    photo: [anastasiaKapchenovaPhoto],
    stars: 5,
  },
  {
    name: 'Симон Симон',
    avatar: simonSimon,
    caption: 'Счастливый коллекционер',
    headline: 'РОСКОШЬ И ПЕРСОНАЛЬНЫЙ ПОДХОД',
    text: `Без сомнения, один из лучших опытов покупки часов в моей жизни. Sany Watches — это не просто магазин часов, это настоящая роскошная атмосфера.
С самого момента, как я вошёл в шоурум, был искренне впечатлён. Современно, стильно, и с тем ощущением премиального сервиса, которое сразу даёт понять — ты в нужном месте.
Больше всего поразил персональный подход. Они не пытались что-то просто продать — они действительно старались понять, чего я хочу, и помогли найти идеальные часы, которые соответствуют моему стилю и коллекции.
`,
    stars: 5,
  },
  {
    name: 'Анна Капченова',
    avatar: annaKapchenova,
    caption: 'Довольная покупательница',
    headline: 'ДРУЖЕЛЮБНЫЙ СЕРВИС БЕЗ ДАВЛЕНИЯ',
    text: `Отличный опыт покупки часов. Команда была дружелюбной и профессиональной. Помогли подобрать идеальный стиль без какого-либо давления. Очень рекомендую!`,
    stars: 5,
  },
  {
    name: 'Бенджамин zw',
    avatar: benjaminZw,
    caption: 'Довольный клиент',
    headline: 'ЛУЧШАЯ ЦЕНА И БЫСТРОЕ ОБСЛУЖИВАНИЕ',
    text: `Я всегда покупаю новые часы в Sany по самым выгодным ценам. Быстрое обслуживание, отличный выбор и непревзойдённое соотношение цены и качества, очень рекомендую`,
    stars: 5,
  },
  {
    name: 'Тема Добрый',
    avatar: temaDobry,
    caption: 'Счастливый клиент',
    headline: 'РЕДКИЕ МОДЕЛИ И VIP-АТМОСФЕРА',
    text: `Это лучшее место для покупки часов! Я получил очень редкие часы за 1 день (по очень хорошей цене), пригласили в офис, угостили напитком, предложили кальян. В общем, теперь хожу за часами только туда. (Кстати, помимо часов у них есть сумки Birkin, лабутены и аксессуары!)`,
    stars: 5,
  },
  {
    name: 'Даниэль Салимов',
    avatar: danielSalimov,
    caption: 'Счастливый покупатель',
    headline: 'ОТВЕТЫ СРАЗУ, ВЫБОР НА ЛЮБОЙ ВКУС',
    text: 'Отличный выбор часов. Рафаэль оперативно ответил на все вопросы. Определённо рекомендую!',
    stars: 5,
  },
  {
    name: 'Гриша Хаспекян',
    avatar: grishaKhaspekyan,
    caption: 'Довольный клиент',
    headline: 'ЧАСЫ, О КОТОРЫХ МЕЧТАЛ',
    text: `Спасибо Рафаэлю за то, что помог мне приобрести именно те часы, которые я действительно хотел. Шоурум — просто потрясающий, а сервис на высшем уровне. Спасибо, Рафаэль и Sany Watches!`,
    photo: [grishaKhaspekyanPhoto],
    stars: 5,
  },
  {
    name: 'Иван Румянцев',
    avatar: ivanRumyantsev,
    caption: 'Довольный покупатель',
    headline: 'УНИКАЛЬНЫЕ ПРЕДЛОЖЕНИЯ И ЛУЧШАЯ ЦЕНА',
    text: 'Самые уникальные предложения и объективно лучшая цена на рынке. Большое спасибо Рафаэль и команда!',
    stars: 5,
  },
  {
    name: 'Вартан Миракян',
    avatar: vartanMirakyan,
    caption: 'Счастливый клиент',
    headline: 'КАЧЕСТВО И СЕРВИС НА ВЫСОТЕ',
    text: `Лучшие в своём деле!  
Сервис и качество — на высшем уровне`,
    stars: 5,
  },
  {
    name: 'Стефани Т',
    avatar: stephanieT,
    caption: 'Счастливая покупательница',
    headline: 'ШОУРУМ, КОТОРЫЙ ПОРАЖАЕТ',
    text: `Самый красивый и лучший шоурум в ОАЭ!!🤩🤩  
Было очень сложно выбрать, потому что всё просто ВАУУУУ!!  
Отличный опыт!  
Огромное спасибо, рекомендую всем, кто хочет лучшее по лучшей цене!  
До скорой встречи!!!❤️❤️❤️`,
    stars: 5,
  },
];